import { createApp } from 'vue';
import './plugins/assets';
import { setupDayjs, setupIconifyOffline, setupLoading, setupNProgress } from './plugins';
import { setupStore } from './store';
import { useQueryParmStore } from './store/modules/query-parm';
import { refreshUserInfoFromServer } from './store/modules/auth/shared';
import { setupRouter } from './router';
import { setupI18n } from './locales';
import App from './App.vue';

async function setupApp() {
  setupLoading();

  setupNProgress();

  setupIconifyOffline();

  setupDayjs();

  const app = createApp(App);

  setupStore(app);

  // 已登录时 F5 / 硬刷新：在路由初始化前同步最新 userInfo（含 sub_admin 权限）
  await refreshUserInfoFromServer();

  const queryParmStore = useQueryParmStore();
  void Promise.all([
    queryParmStore.setOverviewCountryOptionsAsync(),
    queryParmStore.setOverviewChannelOptionsAsync()
  ]);

  await setupRouter(app);

  setupI18n(app);

  app.mount('#app');
}

setupApp();
